import { Component, Injector, ViewChild, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { AbstractControl } from "@angular/forms";
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { MomentFormatPipe } from "shared/utils/moment-format.pipe";

function startDateBeforeEndDate(c: AbstractControl) { }

@Component({
    selector: 'dateRange',
    templateUrl: './date-range.component.html',
    animations: [appModuleAnimation()],
    providers: [MomentFormatPipe]
})
export class DateRangeComponent extends AppComponentBase implements AfterViewInit {

    @ViewChild('startDateObject', { static: true }) startDateCalendar;
    @ViewChild('endDateObject', { static: true }) endDateCalendar;

    @Input() startDateStringInput: string;
    @Output() startDateStringInputChange: EventEmitter<any> = new EventEmitter();
    @Input() endDateStringInput: string;
    @Output() endDateStringInputChange: EventEmitter<any> = new EventEmitter();
    @Input() styleClass?: string;
    @Input() inputStyleClass?: string;

    @Output() ngOnChangesEvent: EventEmitter<any> = new EventEmitter();

    @Input() public required: boolean = false;

    validInputs: { isValid: boolean, errorMessage: string};

    constructor(
        injector: Injector,
        private _momentFormatPipe: MomentFormatPipe
    ) {
        super(injector);
    }

    ngAfterViewInit() {
        this.validate();
    }

    ngOnChanges() {
        this.validate();
        this.ngOnChangesEvent.emit();
    }

    emitStartDate() {
        this.startDateStringInputChange.emit(this.startDateStringInput);
    }

    emitEndDate() {
        this.endDateStringInputChange.emit(this.endDateStringInput);
    }

    dateRangeValid(): boolean {
        return this.validInputs.isValid;
    }

    validate(): void {
        var startDate: Date = this.startDateCalendar.inputDate;
        var endDate: Date = this.endDateCalendar.inputDate;

        if (!this.validateRequired()) {
            this.validInputs = { isValid: false, errorMessage: 'Date Range Is Required'};
            return;
        }

        if (!this.validateStartBeforeEnd()) {
            this.validInputs = { isValid: false, errorMessage: 'Start Date Must Come Before End Date'};
            return;
        }

        this.validInputs = { isValid: true, errorMessage: null };
    }

    validateRequired(): boolean {
        return !(this.required && (this.startDateCalendar.inputDate == null || this.endDateCalendar.inputDate == null));
    }

    validateStartBeforeEnd(): boolean {
        var startDate: Date = this.startDateCalendar.inputDate;
        var endDate: Date = this.endDateCalendar.inputDate;

        return !((startDate != null || endDate != null) && (startDate > endDate));
    }
}
